import { useEffect, useRef, useState } from "react";
import { GET, GetFile } from "../../utils/httpUtils";

import defaultProfilePicture from "../../assets/images/defaultProfilePicture.png";
import { MAX_PREVIEW_MB } from "../../environmentVariables";
import { BytesToMb, isMobileDevice, Log, TruncateText, wait } from "../../utils/genericUtils";

import exitIcon from "../../assets/images/exitLight.png";

const defaultProps = {
  user: {},
  dir: "",
  isPublicView: false,
  ownerUserName: null,
  setDir: () => {},
};
export default function DirectoryComponent(props = defaultProps) {
  const [publicProfilePicture, setPublicProfilePicture] = useState(defaultProfilePicture);
  const mobileClickCount = useRef(0);

  useEffect(() => {}, [props.isPublicView, props.ownerUserName]);

  useEffect(() => {
    if (props.isPublicView && props.ownerUserName) {
      //get the users profile picture url
      GET(`/public-profile-picture/${props.ownerUserName}`).then((res) => {
        if (res.success && res.profile_picture) {
          //download the picture
          GetFile(res.profile_picture)
            .then((file) => {
              setPublicProfilePicture(file.url);
            })
            .catch((err) => {
              Log("get file error: ", err);
            });
        }
      });
    }
  }, [props.isPublicView, props.ownerUserName]);

  //common
  const current_dir_controls = () => {
    if (props.isPublicView && !props.ownerUserName) return;
    return (() => {
      let dirPaths = [];
      let dirPathEls = [];

      let parts = props.dir.split("/");

      Array.from(parts).map((directory, index = 0) => {
        var _dir = dirPaths.join("/") + "/" + directory;

        if (_dir.charAt(0) != "/") _dir = "/" + _dir;

        if (index === 0 && props.isPublicView && props.ownerUserName) {
          dirPathEls.push(
            <h5
              key={"root-dir"}
              className="dir-text"
              onClick={() => {
                props.setDir("/");
              }}
            >
              @{props.ownerUserName}
            </h5>
          );
        }

        let dir_limit = isMobileDevice() ? 4 : 5;

        if (index === 1 && parts.length >= dir_limit) {
          dirPathEls.push(
            <h5 key={"root-dir"} className="dir-text no-hover">
              ...
            </h5>
          );
        }

        if (parts.length >= dir_limit) {
          //only show last three dirs
          if (index > parts.length - (dir_limit - 1)) {
            dirPathEls.push(
              <h5
                data-dir={_dir}
                key={index + 5}
                className="dir-text"
                onClick={() => {
                  props.setDir(_dir);
                }}
              >
                {isMobileDevice() ? TruncateText(directory, 7) : TruncateText(directory, 20)}
              </h5>
            );
          }
        } else {
          dirPathEls.push(
            <h5
              data-dir={_dir}
              key={index + 5}
              className="dir-text"
              onClick={() => {
                props.setDir(_dir);
              }}
            >
              {directory}
            </h5>
          );
        }

        //join paths with /
        dirPaths.push(directory.replaceAll("/", ""));

        if (parts.length > dir_limit) {
          //do not allow /...///dir/dir (consecutive slashes)
          if (dirPathEls[dirPathEls.length - 1] && dirPathEls[dirPathEls.length - 1].props.children !== "/") {
            dirPathEls.push(
              <h5 key={-1 * index - 5} className="dir-text no-hover">
                /
              </h5>
            );
          }
        } else {
          if (index >= 1 || parts[1] !== "trash") {
            dirPathEls.push(
              <h5 key={-1 * index - 5} className="dir-text no-hover">
                /
              </h5>
            );
          }
        }
      });

      return dirPathEls;
    })();
  };

  let dir_parts = props.dir.toLowerCase().split("/");
  if (dir_parts[0] === "trash" || dir_parts[1] === "trash") {
    return (
      <section className="dir-section dir-trash">
        <h5 className="dir-text no-hover trash-header">Trash Bin</h5>
        <p className="bin-subtext">Files and folders in the trash bin will be permenantly deleted after 7 days.</p>
        <div className="trash-dirs">
          {/*Logic for the current directory*/}
          {current_dir_controls()}
        </div>
      </section>
    );
  }

  function showEnlargedImagePreview() {
    let isMobile = isMobileDevice();

    if (isMobile) {
      const nextClickCount = mobileClickCount.current + 1;
      mobileClickCount.current = nextClickCount;
      //reset count to zero if they do not double click in 1.5s
      wait(700, () => (mobileClickCount.current = 0));
      if (nextClickCount < 2) return;
    }

    let id = "click-" + props.ownerUserName + "-img-expanded-preview";
    let imagePreview = document.querySelector("#" + id);
    imagePreview.style.display = "flex";
    imagePreview.querySelector(".target-enlarged-image").src = publicProfilePicture;
  }

  function hideEnlargedImagePreview(e) {
    e.stopPropagation();
    let id = "click-" + props.ownerUserName + "-img-expanded-preview";
    let imagePreview = document.querySelector("#" + id);
    imagePreview.style.display = "none";
  }

  return (
    <>
      {props.isPublicView && (
        <>
          {/* Image Expanded Modal */}
          <div id={"click-" + props.ownerUserName + "-img-expanded-preview"} className="expanded-preview">
            <button
              onClick={(e) => {
                //stop propagation of this event
                hideEnlargedImagePreview(e);
              }}
              className="expanded-preview-exit-button"
            >
              <img src={exitIcon} alt="exit icon" />
            </button>
            <img className="target-enlarged-image" src="" alt={"image file: " + props.objectName} />
          </div>
          {/* Profile Picture */}
          <div className="profile-picture-container public-profile-pic">
            <img
              className="profile-picture"
              src={publicProfilePicture}
              onClick={showEnlargedImagePreview}
              onError={(e) => (e.target.src = defaultProfilePicture)}
              alt=""
            />
          </div>
        </>
      )}

      <section className="dir-section">
        {!props.isPublicView && (
          <h5
            className="dir-text root-dir"
            onClick={() => {
              props.setDir("/");
            }}
          >
            {props.user ? props.user.username : ""}
          </h5>
        )}

        {/*Logic for the current directory*/}
        {current_dir_controls()}
      </section>
    </>
  );
}
